import React from 'react';
import Heading from '../../Heading/JavaScript/Heading';
import HexagonFrame from '../Assets/HexagonFrame.svg';
import HS_DP from '../Assets/HS_DP.png';
import MainPageName from '../Assets/MainPageName.png';

function Introduction() {
    return (
        <section className="introduction">
            <picture className="introduction__img" data-aos="fade-up" data-aos-delay="300">
                <img src={MainPageName} alt="HAIDER SULTAN" />
            </picture>
            
            <Heading heading="About Me" />
            
            <div className="introduction__text">
                <div className="introduction__text__intro">
                    <p data-aos="fade-up" data-aos-delay="550">
                        Hi, My name is <span>Haider Sultan</span>. I am from Lahore, <span>Pakistan</span>. I am a self-taught Developer and Computer Scientist.
                        I am a 2nd Year CS Student at the University of Engineering and Technology, Lahore. 
                        I am a tech enthusiast with interest in: <span>Artificial Intelligent</span>, <span>Cyber Security</span>, <span>BlockChain</span>, and <span>DevOps</span>.
                    </p>
                    <p data-aos="fade-up" data-aos-delay="600">
                        I am always learning new skills and trying to challenge myself. I take part in Hackathons
                        and other Coding Challenges. I am also a freelancer and Leader of <span>ArcCode</span> Team of Freelancers.
                        Coding is not a job for me it's more like a hobby. I am passionate about it and I love it.
                    </p>
                    <p data-aos="fade-up" data-aos-delay="650">
                        I am also passionate about <span>Open-Source</span> Softwares and Contributions. 
                        I like to contribute to <span>Open-Source</span> and dig deep into the workflow of large Organizations.
                        I aim to make the world a better place.
                    </p>
                </div>
                <div className="introduction__text__dp" data-aos="fade-up" data-aos-delay="500">
                    <div className="introduction__text__dp__hexagonFrame">
                        <img src={HexagonFrame} alt="Hexagon Frame" />
                    </div>
                    <picture className="introduction__text__dp__hexagon">
                        <img src={HS_DP} alt="HS" />
                    </picture>
                    <div className="introduction__text__dp__hexagonBorder">
                    <div className="introduction__text__dp__hexagonBorder__1"></div>
                    <div className="introduction__text__dp__hexagonBorder__2"></div>
                    <div className="introduction__text__dp__hexagonBorder__3"></div>
                    <div className="introduction__text__dp__hexagonBorder__decoration">
                        <div className="introduction__text__dp__hexagonBorder__decoration__1"></div>
                        <div className="introduction__text__dp__hexagonBorder__decoration__2"></div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
}

export default Introduction


// WEBPACK FOOTER //
// ./src/Components/Introduction/JavaScript/Introduction.js